import Upload from './upload';

import './style';

export default Upload;
